import { HStack } from '@chakra-ui/react';
import CoordinatesControl from '@components/map/controls/CoordinatesControl';
import ScaleControl from '@components/map/controls/ScaleControl';
import { useMapViewState } from '@components/map/useMapViewState';
import BaseMap from '@components/ui/map/BaseMap';
import { ReactNode, RefObject, useRef } from 'react';
import { MapRef } from 'react-map-gl/mapbox';

import { LayerNameEnum, MapIdEnum } from '@/types/map.types';

interface VisualizationMapProps {
  children: (params: {
    mapRef: RefObject<MapRef | null>;
    mapConstraintsRef: RefObject<HTMLDivElement | null>;
  }) => ReactNode;
  selectableLayers?: LayerNameEnum[];
  handleLoad?: (mapRef: RefObject<MapRef | null>) => void;
}

function VisualizationMap({ children, selectableLayers, handleLoad }: Readonly<VisualizationMapProps>) {
  const mapRef = useRef<MapRef>(null);
  const mapConstraintsRef = useRef<HTMLDivElement>(null);
  const { state: mapViewState, setViewState } = useMapViewState();

  return (
    <BaseMap
      mapId={MapIdEnum.CONFIG_VIEW}
      mapRef={mapRef}
      mapConstraintsRef={mapConstraintsRef}
      selectableLayers={selectableLayers}
      viewState={mapViewState.viewState}
      setViewState={setViewState}
      onLoad={handleLoad ? () => handleLoad(mapRef) : undefined}
    >
      <HStack
        gap={2}
        position="absolute"
        flex={1}
        right={0}
        bottom={0}
        fontFamily="roboto"
        textStyle="sm"
        height="40px"
        margin={2}
        alignItems="stretch"
        userSelect="none"
      >
        <ScaleControl zoom={mapViewState.viewState.zoom} />
        <CoordinatesControl viewState={mapViewState.viewState} />
      </HStack>
      {children({ mapRef, mapConstraintsRef })}
    </BaseMap>
  );
}

export default VisualizationMap;
